import { type OrderItem, OrderItemType } from '../types/OrderItem';

/**
 * Extracts fee items from order items list.
 * Fee items are items with type === 'fee'.
 */
export const getFeeItems = (orderItems: OrderItem[] = []): OrderItem[] => {
  return orderItems.filter((item) => item.type === OrderItemType.Fee);
};

/**
 * Extracts product items from order items list.
 * Product items are items with type === 'product' or without type field (default).
 */
export const getProductItems = (orderItems: OrderItem[] = []): OrderItem[] => {
  return orderItems.filter((item) => !item.type || item.type === OrderItemType.Product);
};
